import React from 'react';
import { Button, Icon } from '@virtidev/toolbox';
import * as Styled from './ChatRequestError.styled';
import PropTypes from 'prop-types';

const ChatRequestError = ({ error, onResend }) => {
  return (
    <Styled.ErrorWrapper>
      <Styled.ChatError>
        <Icon icon="alert" />
        <div>{error}</div>
      </Styled.ChatError>
      <div>
        <Button size="small" color="primary" onClick={onResend}>
          Resend
        </Button>
      </div>
    </Styled.ErrorWrapper>
  );
};

ChatRequestError.propTypes = {
  error: PropTypes.string,
  onResend: PropTypes.func,
};

export default ChatRequestError;
